import {api} from "./index";
import {AuditLog, auditLogStore} from "../redux/entities/auditlog";
import {AuditLogState} from "../redux/stateResponses/auditLogState";

export async function getAuditLogs() : Promise<AuditLogState> {
  const resp = await api.get<AuditLogState>('Auditlog');
  return resp.data;
}

export async function getAuditLogsContainingId(id: string): Promise<AuditLogState> {
  const resp = await api.get<AuditLogState>(`Auditlog/${id}`);
  return resp.data;
}
